<ng-template [ngIf]="theme && theme.themeData" [ngIfElse]="baryTheme">
  <div class="alert text-center alert-info" role="alert" *ngIf="transporter?.technicalName === TransporterEnum.ABO.technicalName">
    <h4 [innerHTML]="'TEMP_DASHBOARD_MESSAGE_ABO_RENAMING' | translate"></h4>
  </div>
  <div class="wepal-homepage">
    <section class="section-sub-header text-center">
      <div class="row no-gutters">
        <div class="col-4">
          <p class="lead pt-3">
            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="32.625" height="28.275" viewBox="0 0 32.625 28.275">
              <g id="truck" transform="translate(-1.5 -4.5)">
                <path
                  id="Tracé_22"
                  data-name="Tracé 22"
                  d="M30.447,10.865a2.177,2.177,0,0,0-1.782-.928H23.25V6.675A2.177,2.177,0,0,0,21.075,4.5H3.675A2.177,2.177,0,0,0,1.5,6.675V28.969H5.108a4.621,4.621,0,0,0,9.1,0H21.42a4.621,4.621,0,0,0,9.1,0h3.608V16.634a1.623,1.623,0,0,0-.295-.935ZM3.674,6.675h17.4V18.638H3.675ZM9.656,30.6A2.447,2.447,0,1,1,12.1,28.153,2.447,2.447,0,0,1,9.656,30.6Zm16.313,0a2.447,2.447,0,1,1,2.447-2.447A2.447,2.447,0,0,1,25.969,30.6Zm5.981-3.806H30.386a4.622,4.622,0,0,0-8.835,0H14.074a4.622,4.622,0,0,0-8.835,0H3.675V20.813H31.95Zm0-8.156h-8.7V12.112h5.415l3.285,4.693Z"
                  fill="$secondary"
                />
              </g>
            </svg>
            <span class="d-block d-md-inline-block pt-2 pt-md-0" jhiTranslate="baryApp.themeData.subHeaderItem1"></span>
          </p>
        </div>
        <div class="col-4">
          <p class="lead pt-3">
            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="24.236" height="28.275" viewBox="0 0 24.236 28.275">
              <g id="security" transform="translate(-6 -3)">
                <path
                  id="Tracé_23"
                  data-name="Tracé 23"
                  d="M19.039,21.655l-2.615-2.615L15,20.463,19.039,24.5l8.079-8.079L25.694,15Z"
                  transform="translate(-2.941 -3.921)"
                  fill="$secondary"
                />
                <path
                  id="Tracé_24"
                  data-name="Tracé 24"
                  d="M18.118,31.275,11.881,27.95A11.09,11.09,0,0,1,6,18.147V5.02A2.022,2.022,0,0,1,8.02,3h20.2a2.022,2.022,0,0,1,2.02,2.02V18.147a11.09,11.09,0,0,1-5.881,9.8ZM8.02,5.02V18.147a9.073,9.073,0,0,0,4.813,8.02l5.285,2.818L23.4,26.168a9.073,9.073,0,0,0,4.813-8.021V5.02Z"
                  fill="$secondary"
                />
              </g>
            </svg>
            <span class="d-block d-md-inline-block pt-2 pt-md-0" jhiTranslate="baryApp.themeData.subHeaderItem2"></span>
          </p>
        </div>
        <div class="col-4">
          <p class="lead pt-3">
            <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="28.275" height="28.275" viewBox="0 0 28.275 28.275">
              <g id="track" transform="translate(-6 -6)">
                <g id="Groupe_24" data-name="Groupe 24" transform="translate(6 6)">
                  <path
                    id="Tracé_25"
                    data-name="Tracé 25"
                    d="M22.713,27.425A4.713,4.713,0,1,0,18,22.713,4.713,4.713,0,0,0,22.713,27.425Z"
                    transform="translate(-8.575 -8.575)"
                    fill="$secondary"
                  />
                  <path
                    id="Tracé_26"
                    data-name="Tracé 26"
                    d="M20.138,6a1.571,1.571,0,0,1,1.571,1.571V9.252a11,11,0,0,1,9.315,9.315H32.7a1.571,1.571,0,1,1,0,3.142H31.023a11,11,0,0,1-9.315,9.315V32.7a1.571,1.571,0,0,1-3.142,0V31.023a11,11,0,0,1-9.315-9.315H7.571a1.571,1.571,0,0,1,0-3.142H9.252a11,11,0,0,1,9.315-9.315V7.571A1.571,1.571,0,0,1,20.138,6ZM12.283,20.138a7.854,7.854,0,1,1,7.854,7.854A7.854,7.854,0,0,1,12.283,20.138Z"
                    transform="translate(-6 -6)"
                    fill="$secondary"
                    fill-rule="evenodd"
                  />
                </g>
              </g>
            </svg>
            <span class="d-block d-md-inline-block pt-2 pt-md-0" jhiTranslate="baryApp.themeData.subHeaderItem3"></span>
          </p>
        </div>
      </div>
    </section>

    <section class="section-splash pt-5">
      <div class="align-content-center px-0 mx-lg-auto" *ngIf="transporter">
        <div class="text-center col-12">
          <div class="col-12 col-md-5 mx-lg-auto">
            <img
              [alt]="'logo ' + transporter!.technicalName + '.png'"
              class="mx-lg-auto img-fluid"
              (error)="logo = './../../../content/images/logos/demo/demo-sidenav.png'"
              [src]="environment.urlApi + logo"
            />
          </div>
          <h2 class="mb-3 pt-4">{{ theme.themeData!.mainSplashMessage }}</h2>
        </div>
        <div class="mt-5">
          <jhi-wepal-light-estimate></jhi-wepal-light-estimate>
        </div>
      </div>
    </section>

    <hr class="wepal-hr col-8" />

    <section class="section-carousel align-content-center pb-1">
      <div class="col-12 col-lg-4 mx-lg-auto pb-5 text-center" *ngIf="transporter">
        <h2 class="mb-3 pt-4" jhiTranslate="baryApp.themeData.carouselTitle" [translateValues]="{ shopName: transporter.shopName }"></h2>
      </div>
      <div class="col-8 mt-5 mb-5 text-center m-auto">
        <owl-carousel-o [options]="carouselOptions">
          <ng-template carouselSlide *ngFor="let carouselItem of slides; let i = index">
            <mdb-card>
              <mdb-card-img [src]="environment.urlApi + carouselItem.image" alt="Card image cap"></mdb-card-img>
              <mdb-card-body>
                <mdb-card-title>
                  <h4>{{ carouselItem.title }}</h4>
                </mdb-card-title>
                <p [title]="carouselItem.description">{{ carouselItem.description }}</p>
              </mdb-card-body>
            </mdb-card>
          </ng-template>
        </owl-carousel-o>
      </div>
    </section>

    <hr class="wepal-hr col-8" />

    <section class="section-workflow align-content-center">
      <div class="col-12 col-lg-6 mx-lg-auto pb-5 text-center" *ngIf="transporter !== undefined">
        <h2 class="mb-3 pt-4" jhiTranslate="baryApp.themeData.workflowTitle"></h2>
      </div>
      <div class="col-12 col-xl-8 mt-5 mb-5 text-center m-auto">
        <div class="col-12 mx-lg-auto">
          <img alt="workflow" class="mx-lg-auto img-fluid" [src]="environment.urlApi + theme.themeData.transportWorkflowImage" />
        </div>
      </div>
    </section>

    <hr class="wepal-hr col-8" />

    <section class="section-jumbotron align-content-center" *ngIf="theme.themeData.mainJumbotronTitle">
      <div class="col-12 col-xl-8 m-auto">
        <div class="jumbotron text-center hoverable p-0">
          <!-- Grid row -->
          <div class="row">
            <!-- Grid column -->
            <div class="col-12 col-md-4 view">
              <img class="img-jumbotron" alt="main_jumbotron" [src]="environment.urlApi + theme.themeData.mainJumbotronImage" />
            </div>

            <div class="col-12 col-md-8 text-md-left my-4 px-4">
              <h2 class="h2 mb-4">{{ theme.themeData!.mainJumbotronTitle }}</h2>
              <h5 class="h2 mb-2">{{ theme.themeData!.mainJumbotronSubtitle }}</h5>
              <p class="font-weight-normal" [innerHTML]="theme.themeData!.mainJumbotronContent"></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr class="wepal-hr col-8" />

    <section class="section-faq align-content-center" *ngIf="theme.themeData.faqs.length > 0">
      <div class="col-12 col-lg-4 mx-lg-auto pb-5 text-center">
        <h2 class="mb-3 pt-4" jhiTranslate="baryApp.themeData.questionsTitle"></h2>
      </div>
      <div class="col-12 col-lg-8 mt-5 mb-5 text-center m-auto">
        <mdb-accordion>
          <div *ngFor="let faq of theme.themeData.faqs" class="mb-1">
            <mdb-accordion-item>
              <mdb-accordion-item-head class="mr-4">{{ faq.question }}</mdb-accordion-item-head>
              <mdb-accordion-item-body>
                <p>{{ faq.answer }}</p>
              </mdb-accordion-item-body>
            </mdb-accordion-item>
          </div>
        </mdb-accordion>
      </div>
    </section>

    <hr class="wepal-hr col-8" />

    <!-- Footer -->
    <footer class="page-footer">
      <div class="container col-12 col-xl-8 pt-5">
        <div class="row text-center transporter-wrapper">
          <div class="description col-12 col-md-4">
            <div class="pb-4 mx-lg-auto text-left">
              <h3>{{ theme.themeData.footerTransporterName }}</h3>
            </div>
            <p class="pb-4 color-white text-left">{{ theme.themeData.footerTransporterDescription }}</p>
            <div
              class="col-12 col-md-10 wrapper-evolutrans"
              *ngIf="theme.themeData.footerTransporterGroup.length > 0 && theme.themeData.footerTransporterGroup.valueOf() !== 'aucun'"
            >
              <img [alt]="'logo_groupement.png'" class="mx-lg-auto img-fluid" [src]="theme.themeData.footerTransporterGroup.valueOf()" />
            </div>
          </div>
          <div class="col-12 col-md-4 text-center">
            <div class="row">
              <div class="pb-3 col-12">
                <h3>{{ 'transporter.middle.services' | translate }}</h3>
              </div>
              <p class="col-12 pb-1">
                <a [routerLink]="['cgv']" target="_blank">
                  {{ 'transporter.middle.cgv.title' | translate }}
                </a>
              </p>
            </div>
          </div>

          <div class="col-12 col-md-4 text-center contact-wrapper">
            <div class="pb-3 col-12">
              <h3>Contact</h3>
            </div>
            <p class="col-12 pb-1 text-white" *ngIf="theme.themeData.footerTransporterPhoneNumber">
              <i class="fas fa-phone footer-icon"></i>
              {{ theme.themeData.footerTransporterPhoneNumber }}
            </p>
            <p class="col-12 pb-1 text-white" *ngIf="theme.themeData.footerTransporterAddress">
              <i class="fas fa-map-marker-alt footer-icon"></i>
              {{ theme.themeData.footerTransporterAddress }}
              {{ theme.themeData.footerTransporterZipcode }}
              {{ theme.themeData.footerTransporterCity }}
            </p>
            <a target="_blank" class="btn bolder" [href]="theme.themeData.footerContactButtonAction">Nous contacter</a>
          </div>
        </div>
      </div>

      <hr class="wepal-hr col-8" />

      <!-- Copyright -->
      <div class="col-12 col-md-8 text-center m-auto pb-4">
        <div class="col-12 col-md-4 m-auto bary-copyright">
          <img [alt]="'logo_transporter_blanc.png'" class="mx-lg-auto img-fluid" [src]="environment.urlApi + theme.themeData.copyrightLogo" />
        </div>
        <div class="col-8 m-auto">
          <span [innerHTML]="getCopyrightMessage()"></span>
        </div>
      </div>
      <!-- Copyright -->
    </footer>
    <!-- Footer -->
  </div>
</ng-template>

<!--- BARY THEME --->
<ng-template #baryTheme>
  <section class="section-splash">
    <div class="align-content-center pt-5 col-lg-8 mx-lg-auto pb-5" *ngIf="transporter !== undefined">
      <div class="text-center col-12">
        <div class="col-12 col-md-6 mx-lg-auto">
          <img
            [alt]="'logo ' + transporter!.technicalName + '.png'"
            class="mx-lg-auto img-fluid"
            (error)="logo = './../../../content/images/logos/demo/demo-sidenav.png'"
            [src]="environment.urlApi + logo"
          />
        </div>

        <h2 jhiTranslate="dashboard.intro.text1_disconnected" class="mb-3 pt-4" [translateValues]="{ shopName: transporter.shopName, shopNamePonctuation: '!' }"></h2>
        <p class="default mb-4" jhiTranslate="dashboard.intro.text2_disconnected"></p>
      </div>
      <div class="col-12">
        <jhi-bary-light-estimate></jhi-bary-light-estimate>
      </div>
    </div>
  </section>
</ng-template>
